import { addDays, format } from 'date-fns';

export const isToday = (date: number | Date) => format(date, 'yyyy-MM-dd') === format(Date.now(), 'yyyy-MM-dd');

export const isTomorrow = (date: number | Date) =>
  format(date, 'yyyy-MM-dd') === format(addDays(Date.now(), 1), 'yyyy-MM-dd');

export const formatDateWithRelativeText = (date: number | Date) =>
  `${isToday(date) ? 'Today' : isTomorrow(date) ? 'Tomorrow' : format(date, 'P')} at ${format(date, 'HH:mm')}`;

export const parseDate = (str: string | undefined) => {
  if (!str) {
    return undefined;
  }
  const date = Date.parse(str);
  if (Number.isNaN(date)) {
    return undefined;
  }
  return new Date(date);
};

export const formatDateRange = (startDate: number | Date, endDate: number | Date) => {
  const date = `${isToday(startDate) ? 'Today' : isTomorrow(startDate) ? 'Tomorrow' : format(startDate, 'LLL d')}`;
  const time = `${format(startDate, 'p')} - ${format(endDate, 'p')}`;
  return `${date} ${time}`;
};
